import { useState } from 'react';

interface ShareButtonsProps {
  title: string;
  text: string;
  /** Defaults to the current page. */
  url?: string;
  className?: string;
}

/**
 * Native share sheet where the browser has one (phones), otherwise copy the
 * link, plus text and email links that work everywhere.
 */
export function ShareButtons({ title, text, url, className }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const href = url ?? (typeof window !== 'undefined' ? window.location.href : '');
  const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  const share = async () => {
    try {
      await navigator.share({ title, text, url: href });
    } catch {
      // dismissed
    }
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };
  const body = encodeURIComponent(`${text} ${href}`);
  const btn = 'btn-outline px-4 py-2 text-sm';

  return (
    <div className={`flex flex-wrap gap-3 ${className ?? ''}`} aria-label="Share this page">
      {canShare ? (
        <button type="button" onClick={() => void share()} className={btn}>
          Share
        </button>
      ) : (
        <button type="button" onClick={() => void copy()} className={btn}>
          {copied ? 'Link copied' : 'Copy link'}
        </button>
      )}
      <a href={`sms:?&body=${body}`} className={btn}>
        Text it
      </a>
      <a href={`mailto:?subject=${encodeURIComponent(title)}&body=${body}`} className={btn}>
        Email it
      </a>
    </div>
  );
}
